import { render, staticRenderFns } from "./firstTable.vue?vue&type=template&id=224b0252&scoped=true"
import script from "./firstTable.vue?vue&type=script&lang=js"
export * from "./firstTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224b0252",
  null
  
)

export default component.exports